<template>
    <div class="box-container" v-if="lawyers">
        <img src="../assets/appIcons/Pics/Stamp.png" class="stamp-pic" id="stamp-pic-one" alt="">
        <img src="../assets/appIcons/Pics/Stamp.png" class="stamp-pic" id="stamp-pic-two" alt="">
        <div id="home-section-four" class="container-size-fixer">
            <div id="header">
                همکاران
                <span style="color: #cc171d">
                کانادا از ایران
            </span>
            </div>
            <div v-if="lawyers">
                <div id="cart-container"  v-if="lawyers && lawyers.length===3">
                    <div  v-for="(lawyer,index) in lawyers" :key="lawyer">
                        <transition name="slide-fade" >
                            <div v-if="showCart.one===index" @click="changeCart('one',index)" class="lawyer-image-preview-one">
                                <img :src="$store.state.base_urls.webUploads+lawyer.image" :alt="lawyer.name">
                            </div>
                        </transition>
                    </div>


                    <div  v-for="(lawyer,index) in lawyers" :key="lawyer">
                        <transition name="slide-fade" >
                            <div v-if="showCart.two===index" @click="changeCart('two',index)" class="lawyer-image-preview-two">
                                <img :src="$store.state.base_urls.webUploads+lawyer.image" :alt="lawyer.name">
                            </div>
                        </transition>
                    </div>

                    <div class="lawyer-details-container">
                        <div  v-for="(lawyer,index) in lawyers" :key="lawyer">
                            <transition name="slide-fade-main">
                                <div v-if="showCart.tree===index" class="row lawyer-details-box">
                                    <div :style="{backgroundImage:'url('+$store.state.base_urls.webUploads+lawyer.image+')'}" class="lawyer-image col-3">
                                        <img src="../assets/appIcons/Pics/Stamp.png" class="stamp-pic stamp-pic-tree" alt="">
                                    </div>
                                    <div class="lawyer-details col-9">
                                        <div class="title">
                                            {{lawyer.name}}
                                        </div>
                                        <div class="introduction">
                                            {{lawyer.explain}}
                                        </div>
                                        <div class="more-details">
                                            <ul>
                                                <li  v-for="item in lawyer.features.split(',')" :key="item">
                                                    <div class="more-details-txt-content">
                                                        {{item}} &nbsp;
                                                    </div>
                                                    <img width="17" height="17" class="more-details-img" src="../assets/appIcons/Pics/CanadaAzIran/Icon/brand-positioning.png" alt="">
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
                <div id="cart-slider"  v-if="lawyers && lawyers.length===3">
                    <flickity  class="flickity" ref="flickity" :options="flickityOptions">
                        <div class="carousel-cell lawyer-details-container" v-for="lawyer in lawyers" :key="lawyer">
                            <div class="row lawyer-details-box slider-box">
                                <div :style="{backgroundImage:'url('+$store.state.base_urls.webUploads+lawyer.image+')'}" class="lawyer-image col-8">
                                    <img src="../assets/appIcons/Pics/Stamp.png" class="stamp-pic stamp-pic-tree" alt="">
                                    <div class="name-container">
                                        <div class="title">
                                            {{lawyer.name}}
                                        </div>
                                        <div class="introduction">
                                            {{lawyer.explain}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </flickity>
                </div>
            </div>
            <div style="height: 350px;padding-top: 105px;" v-if="loadingMood">
                <img style="height: auto;width: 50%" src="../assets/loader/ezgif.com-gif-maker(1).gif" alt="loader">
            </div>
        </div>
    </div>
    <div style="margin-top: 10px" v-else></div>
</template>

<script>
    import Flickity from 'vue-flickity'
    import axios from 'axios'
    export default {
        name: "HomeSectionFour",
        components:{
            Flickity
        },
        data () {
            return {
                lawyers : null,
                loadingMood:false,
                showCart:
                    {
                        one:0,
                        two:1,
                        tree:2
                    },
                flickityOptions: {
                    initialIndex: 1,
                    prevNextButtons: true,
                    pageDots: false,
                    wrapAround: true,
                    freeScroll: true,
                    rightToLeft: true,
                    arrowShape: {
                        x0: 30,
                        x1: 45, y1: 20,
                        x2: 55, y2: 20,
                        x3: 40
                    }
                }
            }
        },
        methods:{
            changeCart:function (item,cart) {
                if(item==='one'){
                    if(this.showCart.tree!==cart){
                        this.showCart.one=this.showCart.tree;
                        this.showCart.tree=cart;
                    }
                }else{
                    if(this.showCart.tree!==cart){
                        this.showCart.two=this.showCart.tree;
                        this.showCart.tree=cart;
                    }

                }
            },
            async getPageInfos() {
                try {
                    this.loadingMood = true;
                    let response = await axios.get('api/getLawyersFeatures/3',);
                    this.loadingMood = false;
                    this.lawyers = response.data.results;
                } catch (error) {
                    console.log(error)
                }
            },
        },
        mounted() {
            this.getPageInfos();
        },
    }
</script>

<style lang="scss" scoped>
    .name-container{
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        padding-left: 15px;
        padding-right: 15px;
        backdrop-filter: blur(6px);
        .title{
            color: black;
            opacity: 1;
            font-size: 15px;
        }
        .introduction{
            opacity: 1;
            color: gray;
            font-size: 15px;
        }
    }
    .slider-box{
        justify-content: center;
    }
    .lawyer-details-box{
        width: 96%;
        height: 90%;
        left: 0%;
        right: 0%;
        margin: auto;
        position: absolute;
    }
    .slide-fade-enter-active {transition: all 1s;}
    .slide-fade-leave-active {transition: all 1s}
    .slide-fade-leave-to {transform: translateX(-100px);opacity: 0;}
    .slide-fade-enter-from {transform: translateX(100px);opacity: 0;}
    .slide-fade-main-enter-active {
        transition: all 1s;
    }
    .slide-fade-main-leave-active {
        transition: all 1s;
    }
    .slide-fade-main-leave-to {
        transform: translateX(200px);
        opacity: 0;
    }
    .slide-fade-main-enter-from {
        transform: translateX(-200px);
        opacity: 0;
    }
    .lawyer-image-preview-one{
        height: 280px;
        width: 209px;
        padding: 15px;
        display: inline-block;
        img{
            width: auto;
            float: left;
            height: 100%;
            border-radius: 10px;
        }
        position: absolute;
        left: 130px;
        top: 0%;
        bottom: 0%;
        margin: auto;
        z-index: 100;
        border: solid 2px #f2f2f2;
        background-color: #ffffff;
        border-radius: 10px;
    }
    .lawyer-image-preview-two{
        height: 260px;
        width: max-content;
        padding: 15px;
        display: inline-block;
        img{
            width: auto;
            float: left;
            height: 100%;
            border-radius: 10px;
        }
        position: absolute;
        left: 0;
        top: 0%;
        bottom: 0%;
        margin: auto;
        z-index: 50;
        border: solid 2px #f2f2f2;
        background-color: #ffffff;
        border-radius: 10px;
    }
    #cart-container{
        cursor: pointer;
        width: 100%;
        height: auto;
        /*background-color: #4285f4;*/
        position: relative;
    }
    .box-container{
        overflow-x: hidden;
        margin-top: 10px;
        margin-bottom: 10px;
        position: relative;
        min-height: 469px;
        background-color: white;
    }
    .not-selected{
        top: 160px;
        position: absolute;
    }
    #header{
        width: 100%;
        height: auto;
        font-family: 'IRANSans';
        font-size: 36px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
    }
    .introduction{
        opacity: 0.5;
        font-size: 18px;
        text-align: right;
        color: #162336;
    }
    .more-details-img{
        width: 20px;
        height: 20px;
        display: inline;
        position: absolute;
        top: 2px;
    }
    .more-details>ul>li{
        position: relative;
        margin-top: 20px;
        text-align: right;
        height: auto;
        width: 100%;
        display: block;
        font-size: 15px;
        font-weight: 700;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1a1a1a;
    }
    .more-details>ul{
        list-style-type: none;
        height: 180px;
        overflow: hidden;
        overflow-y: scroll;
        width: 105%;
        padding: 0 45px 0 0;
    }
    .more-details>ul::-webkit-scrollbar {
        display: none;
        width: 2px;
    }
    /* Hide scrollbar for IE, Edge and Firefox */
    .more-details>ul{
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
    .title{
        font-family: 'IRANSans';
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        font-size: 22px;
        font-weight: bold;
        color: #162336;
        width: 100%;
    }
    @media (max-width: 1300px) {
        #header{
            font-size: 26px;
            padding: 0 25px;
        }
        #home-section-four{
            padding: 0 25px;
        }
        .more-details, #title{
            padding-right: 25px;
            padding-left: 25px;
        }

    }
    /*************/
    .lawyer-details{
        width:auto;
        height: 100%!important;
    }
    .lawyer-image{
        border-radius: 10px;
        padding: 0;
        background-size: cover;
        background-repeat: no-repeat;
    }
    .lawyer-details-container{
        margin: 30px 0 0 0 !important;
        direction: ltr;
        width: 870px;
        object-fit: contain;
        border-radius: 10px;
        box-shadow: 2px 2px 15px 3px rgba(22, 35, 54, 0.15);
        border: solid 3px #f2f2f2;
        background-color: white;
        padding: 15px;
        min-height: 300px;
        position: relative;
        z-index: 150;
    }
    .stamp-pic{
        width: auto;
        height: 270px;
        margin: 11px 0 49px;
        position: absolute;
        object-fit: contain;
        top: 98px;
        opacity: 0.1;
    }
    .stamp-pic-tree{
        right: -50px;
        width: auto;
        height: 100px;
        position: absolute;
        object-fit: contain;
        top:-20px;
        opacity: 0.9;
    }
    #stamp-pic-one{
        left: -135px;
    }
    #stamp-pic-two{
        right: -135px;
    }
    #home-section-four{
        position: relative;
        width: 100%;
        height: auto;
        margin: auto;
        padding: 30px 0 50px 0;
        /*background-color: red;*/
    }
    #space{
        width: 100%;
        height: 10px!important;
        background-color: #162336;
    }
    #cart-slider{
        width: 100%;
        height: auto;
        display: none;
    }

    .carousel-cell{
        height: auto!important;
        margin: 10px!important;
    }
    @media(max-width: 1190px){
        #cart-container{
            display: none;
        }
        #cart-slider{
            display: block;
        }
    }

    @media(max-width: 1300px){
        .lawyer-details-container{
            width: 95%;
        }
    }
</style>